<template>
  <v-form @submit.prevent="updateRunner" novalidate>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>POZOSTAŁE</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="accent" small v-if="isActiveRunner || isAdmin" @click.prevent="updateMode = !updateMode">edytuj</v-btn>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg3>
        <v-list two-line>
          <runner-data-field
            :editable="updateMode"
            label="Inne aplikacje biegowe"
            description="Konta na innych platformach biegowych np. GarminConnect, PolarFlow, Endomondo itp."
            v-model="form.other_running_platforms_accounts"
            :objValue="runner.other_running_platforms_accounts || 'NIE'"
            :formErrors="formErrors"
            placeholder="jeśli tak to na jakich?"
            :field="'other_running_platforms_accounts'"></runner-data-field>

          <runner-data-field
            v-if="runner.package_with_tshirt"
            :editable="updateMode"
            label="Rozmiar koszulki"
            v-model="form.tshirt_size"
            :objValue="runner.tshirt_size_display"
            :formErrors="formErrors"
            :field="'tshirt_size'">
              <template slot-scope="{ error, label, errorMessages}">
                <v-select
                  v-model="form.tshirt_size"
                  :error="error"
                  :error-messages="errorMessages"
                  :label="label"
                  :items="tshirtSizeOptions">
                </v-select>
                <v-list-tile-sub-title>
                  Sprawdź rozmiar:
                    <v-tooltip open-delay="100" bottom>
                        <span color="primary" slot="activator" id="womanTshirtSize" class="primary--text">damskie</span>
                        <img src="@/assets/img/damskie.png" />
                    </v-tooltip>,
                    <v-tooltip open-delay="100" bottom>
                        <span color="primary" slot="activator" id="manTshirtSize" class="primary--text">męskie</span>
                        <img src="@/assets/img/meskie.png" />
                    </v-tooltip>
                </v-list-tile-sub-title>
              </template>
          </runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Udział w zawodach"
            description="Częstotliwość uczestnictwa w zawodach*"
            required
            v-model="form.race_frequency"
            :objValue="runner.race_frequency_display"
            :formErrors="formErrors"
            :field="'race_frequency'">
              <template slot-scope="{ error, label}">
                <v-select
                  v-model="form.race_frequency"
                  :error="error"
                  :label="label + '*'"
                  :items="raceFrequencyOptions">
                </v-select>
              </template>
          </runner-data-field>
        </v-list>
      </v-flex>

      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg0>
        <v-list two-line>
          <runner-data-field
            :editable="updateMode"
            label="Treningi z trenerem"
            description="Wcześniejsze treningi pod okiem trenera? Jeśli tak to jak długo?"
            v-model="form.training_with_trainer"
            :objValue="runner.training_with_trainer || 'NIE'"
            :formErrors="formErrors"
            :field="'training_with_trainer'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Inne uprawiane sporty"
            v-model="form.other_activities"
            :objValue="runner.other_activities || 'NIE'"
            :formErrors="formErrors"
            :field="'other_activities'"></runner-data-field>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg3>
        <v-btn v-if="updateMode" type="submit" color="primary">Zapisz</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import {updateRunnerData} from './api'
import iziToast from 'izitoast'
import { mapGetters } from 'vuex'
import RunnerDataField from './RunnerDataField'

export default {
  components: {RunnerDataField},
  validators: {},
  props: {
    runner: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isActiveRunner', 'tshirtSizeOptions', 'raceFrequencyOptions'])
  },
  created () {
    this.form = {...this.runner}
  },
  watch: {
    'runner': function (oldVar, newVar) {
      this.form = {...this.runner}
    }
  },
  methods: {
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerData(this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-updated', data)
            iziToast.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            })
            this.updateMode = false
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>
<style>
.bigger .v-list__tile{
  height: 155px;
}
</style>



// WEBPACK FOOTER //
// src/runners/RunnerDataOther.vue